import gql from 'graphql-tag';

import { apolloProvider } from '../../../vueApollo';
import { MUT_ERR_CATEGORIES, MUT_GET_CATEGORIES, MUT_SET_CATEGORIES } from './types';

const nameCollator = new Intl.Collator(undefined, { sensitivity: 'base' });

const state = () => ({
  categories: undefined,
  isLoading: null,
});

const getters = {
  CATEGORIES: (state) => {
    return state.categories;
  },
  ENABLE_CATEGORIES: (state) => {
    if (state.categories) {
      return state.categories.filter((c) => c.enabled === true);
    } else {
      return [];
    }
  },
  CATEGORIES_ISLOADING: (state) => {
    return state.isLoading;
  },
};

// Sequence number of the most recent request; see the action.
let latestRequest = 0;

const actions = {
  async getCategories({ commit, rootState }, orgId) {
    const client = apolloProvider.clients.defaultClient;
    // Requests overlap when the org changes mid-flight (the user switches, or the v3 shell
    // corrects the org this window booted on). The NEWEST request owns this module's data
    // and loading flag: an older response never touches them, and the newest one only
    // lands if its org is still current — otherwise it clears rather than leaves another
    // org's data on screen. CIB-4184.
    const request = ++latestRequest;
    const isLatest = () => request === latestRequest;
    const stillCurrent = () => rootState.currentOrg?.id === orgId;
    commit(MUT_GET_CATEGORIES);
    try {
      const res = await client.query({
        query: gql`
          query GetCategories($orgId: ID!) {
            categories(orgId: $orgId, includeDisabled: true) {
              id
              source
              name
              code
              enabled
              type
              accountingConnectionId
              lastUpdatedSEC
            }
          }
        `,
        variables: {
          orgId,
        },
        fetchPolicy: 'no-cache',
      });
      if (!isLatest()) return;
      if (!stillCurrent()) {
        commit(MUT_ERR_CATEGORIES);
        return;
      }
      commit(MUT_SET_CATEGORIES, res.data.categories);
    } catch (e) {
      if (!isLatest()) return;
      commit(MUT_ERR_CATEGORIES);
    }
  },
};

const mutations = {
  [MUT_GET_CATEGORIES](state) {
    state.isLoading = true;
  },
  [MUT_SET_CATEGORIES](state, categories) {
    // name A–Z, so every picker reading this getter lists them that way
    state.categories = categories
      ? [...categories].sort((a, b) => nameCollator.compare(a.name ?? '', b.name ?? ''))
      : categories;
    state.isLoading = false;
  },
  [MUT_ERR_CATEGORIES](state) {
    state.categories = undefined;
    state.isLoading = false;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
